import React from 'react';

import { Link, Text } from 'lusha-ui-components-v2';

import { IconFactory } from '../../assets/icons/IconFactory';

import './ErrorScreen.scss';

const ErrorScreen = () => (
  <div className="error-screen-container">
    <div className="error-screen-img">
      {IconFactory('Error')}
    </div>
    <div className="error-screen-content">
      <Text className="error-screen-title" variant="largeM" color="seriousBlack">Something went wrong</Text>
      <Text className="error-screen-text" variant="mediumR" color="seriousBlack">
        Please refresh your browser or try again later
      </Text>
      <div className="error-screen-details-container">
        <Text className="error-screen-details" variant="tinyR" color="darkGrey">
          In case the problem continues, please contact our
          <Link className="error-screen-support" size="tiny" href="https://info.lusha.com/en/" target="_blank">support team</Link>
        </Text>
      </div>
    </div>
  </div>
);

export default ErrorScreen;
